import { useEffect } from 'react';

/**
 * Global tracking loader for Google Analytics 4 + Microsoft Clarity.
 *
 * Scripts are only injected when the corresponding env var is present:
 *   - REACT_APP_GA_MEASUREMENT_ID   (e.g. G-XXXXXXXXXX)
 *   - REACT_APP_CLARITY_PROJECT_ID  (e.g. abcd1234ef)
 *
 * Each loader is idempotent – multiple mounts/HMR won't duplicate the
 * script tag. Renders nothing.
 */
const Analytics = () => {
  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (gaId && !document.getElementById('ga4-script')) {
      const s = document.createElement('script');
      s.id = 'ga4-script';
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(s);

      const inline = document.createElement('script');
      inline.id = 'ga4-init';
      inline.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', '${gaId}', { anonymize_ip: true });
      `;
      document.head.appendChild(inline);
    }
  }, []);

  useEffect(() => {
    const clarityId = process.env.REACT_APP_CLARITY_PROJECT_ID;
    if (clarityId && !document.getElementById('clarity-script')) {
      const s = document.createElement('script');
      s.id = 'clarity-script';
      s.text = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityId}");
      `;
      document.head.appendChild(s);
    }
  }, []);

  return null;
};

export default Analytics;
